enum DeviceType {
  ALL = 'All',
  DESKTOP = 'Desktop',
  MOBILE = 'Mobile'
}

export default DeviceType;
